<template>
  <div class="right_container">
    <div style="border-bottom: 1px solid #666;padding: 10px 0;overflow: hidden;line-height: 26px;">
      <div class="right-bar">
        <div class="item" :class="{'keyword':selected=='document_selected'}">
          <span @click="tab('document_selected')">文件列表</span>
        </div>
        <div class="item" :class="{'keyword':selected=='visit'}">
          <span @click="tab('visit')" v-if=" visit_list.list.length > 0">客户拜访</span>
        </div>
      </div>
    </div>

    <!--文档消息-->
    <div v-if=" selected=='document_selected'" :style="{height:(height - 61)+'px'}">
      <!-- <img src="../assets/add_file.png" title=" 上传文件"  class="add_file"> -->
      <div>
        <el-upload
          class="upload-demo"
          :on-success="handleSuccess"
          :action="upload_url"
          :multiple="false"
          :show-file-list="false"
          ref="upload"
          name="file"
          :data="upload_file_data"
          :on-change="change_add_document"
          :auto-upload="true"
          :file-list="fileList"
          :limit="limit"
        >
          <img src="../assets/add_file.png" title=" 上传文件" class="add_file" />
        </el-upload>
        <span>温馨提示：支持上传word、excel、ppt、pdf、图片、视频</span>
      </div>
      <div
        class="newsWapper"
        id="newsWapper"
        :style="'height:'+ (height - 56 - 40) +'px;overflow: auto'"
      >
        <div style="margin: 10px 0" v-if="documents_total.length > 0">
          <div
            class="document_wrapper"
            v-for="(item,index) in  documents_total"
            :class="{'document_list':index%2==0}"
            style="position: relative;"
            :key="index+''"
          >
            <div class="document_info">
              <div>
                <span>{{item.name}}</span>
                <span v-if="item.versions>1">(原文件名:{{item.update_document.name}})</span>
              </div>
              <div>
                <span
                  style="cursor:pointer;"
                  @click="setKeywords(item.keyword,item.id,index)"
                  v-if="item.is_update != 1 && item.del != 2 && item.user_id == user_info.user_id "
                >{{item.keyword=='' || item.keyword== null?'设置关键字':item.keyword}}</span>
                <span v-else>{{item.keyword=='' || item.keyword== null?'':item.keyword}}</span>
              </div>
            </div>

            <div class="document_detail" style="text-align: right">
              <div>{{item.create_time.slice(0,16)}} {{item.user}} / {{item.department}}</div>
              <div v-if="item.is_update != 1 && item.del != 2">
                <span
                  class="function_btn"
                  style="color: #0099CC;"
                  @click="download(item.file.fileurl)"
                >下载</span>

                <span
                  class="function_btn"
                  style="color: #0099CC;"
                  @click="preview(item.file.fileurl,item.type)"
                  v-if="check_item_can_priview(item)"
                >预览</span>
                <span class="function_btn" style="color:black;" title="格式不支持，不能预览，仅可下载。" v-else>不能预览</span>

                <el-upload
                  v-if="item.user_id==user_info.user_id"
                  class="upload-demo"
                  :on-success="handleSuccess_edit"
                  :action="upload_url_edit"
                  :multiple="false"
                  ref="upload"
                  name="file"
                  :data="upload_file_data_edit"
                  :auto-upload="true"
                  :file-list="fileList_edit"
                  :limit="limit"
                >
                  <span class="function_btn" style="color: #0099CC;" @click="file_edit(item.id)">更新</span>
                </el-upload>

                <span
                  class="function_btn"
                  style="color: red;"
                  @click="delDocumentFormList(item.id,item.name,index)"
                  v-if="item.user_id==user_info.user_id"
                >删除</span>
              </div>

              <span
                v-if="item.is_update == 1"
                style="color:red;clear:both;float: right;"
              >已更新为{{item.document.name}}</span>
              <div v-if="item.del == 2">
                <img src="../assets/del.png" style="width: 60px;height: auto;" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 拜访记录 -->
    <div class="recorder_list" v-if="selected=='visit' && visit_list.list.length > 0">
      <div
        class="list cursor"
        onclick
        v-for="(item,index) in visit_list.list"
        @click="visit_detail(item.visit_id)"
        :key="index+''"
      >
        <div class="sidebar_l fl" :style="{backgroundImage: 'url(' + item.img_path + ')'}">
          <div class="vist_info">
            <div class="blnk_bg"></div>
            <div class="vistor">
              {{item.visitor}}
              <span v-if="item.visit_mode == '05'">(第三方位置)</span>
              <span v-if="item.visit_mode == '02'">(客户来访)</span>
              <span v-if="item.visit_mode == '01'">(上门拜访)</span>
              <span v-if="item.visit_mode == '00'">(电话拜访)</span>
            </div>
            <div class="vist_date">{{item.visit_date}}</div>
            <div class="vist_date">{{item.visit_time}}</div>
          </div>
        </div>

        <div class="sidebar_r fl">
          <div class="sidebar_r_top">
            <div class="client_info">
              <span
                class="brand"
              >{{item.client_full_name}}{{item.client_short_name != ''?'/'+ item.client_short_name:''}}</span>
              <span class="staff_wrapper">
                <span>客户人员:</span>
                <span class="staff">{{item.contactor}}</span>
              </span>
            </div>
            <div class="vist_target_content">
              <span class="txt">拜访目的:</span>
              <span class="vist_target">{{item.objective}}</span>
            </div>
            <!--<div class="vist_target_content"><lable class="txt">协同公司:</lable><lable class="cooperative_company">{{item.org_name}}</lable></div>-->
          </div>
          <div class="sidebar_r_bottom">
            <div class="vist_detail fl">
              <div class="details">{{item.industry}}</div>
              <div
                class="details"
              >{{item.center}}{{item.sub_center != ''?'/'+ item.sub_center:''}}{{item.org_name != ''?'/'+ item.org_name:''}}</div>
            </div>

            <!--<div class="fr">-->
            <!--&lt;!&ndash;<span class="del cursor" onclick=""><lable class="del_txt">删除</lable></span>&ndash;&gt;-->
            <!--<a class="number cursor" title="该客户过去一年内的拜访数量">{{item.assocCount}}</a>-->
            <!--</div>-->
          </div>
        </div>
      </div>
      <div style="color: #999;text-align: center" v-if="visit_list.length == 0">暂无拜访记录</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      upload_url: "",
      upload_url_edit: "",
      upload_file_data: { keyword: "" },
      fileList: [],
      limit: 1,
      upload_file_data_edit: {},
      fileList_edit: [],
      documents_list: [],
      selected: "document_selected"
    };
  },
  props: [
    "height",
    "width",
    "visit_list",
    "documents_total",
    "project_id",
    "web_token",
    "user_info",
    "web_url",
    "getDocuments"
  ],
  // store,
  methods: {
    //菜单切换
    tab(name) {
      this.selected = name;
    },
    check_item_can_priview: function(_item) {
      if (_item.type === null) return false;
      if (_item.type === "") return false;
      if (
        _item.type === "MP4" &&
        _item.file.fileurl.toLowerCase().indexOf(".mp4") < 0
      )
        return false;
      return true;
    },
    backToLogin() {
      this.$router.push("/login");
    },
    //默认隐藏保存按钮
    hide_auto_save() {
      this.show_save = false;
    },
    // 设置关键字
    setKeywords(keyword, id, index) {
      var str = keyword == "" || keyword == null ? "设置关键字" : "修改关键字";
      this.$prompt("请输入关键字", str, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: keyword
      })
        .then(({ value }) => {
          this.$http
            .post(
              this.web_url + "/document/" + id + "/edit",
              { web_token: this.web_token, keyword: value },
              { emulateJSON: true }
            )
            .then(function(res) {
              if (res.data.status == "ok") {
                this.getDocuments(this.project_id);
              } else if (res.data.error_code == "401") {
                this.backToLogin();
              }
            })
            .catch(function(res1) {
              console.log(res1);
            });
        })
        .catch(() => {});
    },
    // 更新文档
    file_edit(id) {
      this.upload_url_edit = this.web_url + "/document/" + id + "/edit";
      console.log(this.web_token);
      this.upload_file_data_edit.web_token = this.web_token;
    },
    handleSuccess_edit(res) {
      this.fileList_edit = [];
      this.getDocuments(this.project_id);
    },
    //获取项目所有的文档
    // getDocuments(id){
    //   this.$http.post(this.web_url+'/document',{web_token:this.web_token,limits:10000,project_id:id},{emulateJSON:true}).then(function(res){
    //     if(res.data.status == 'ok'){
    //        this.documents_list = res.data.data.list;
    //        this.function_type = 2;
    //     }else if(res.data.error_code == '401'){
    //       this.backToLogin();
    //     }
    //   })
    //   .catch(function(res1){
    //     // console.log(res1);
    //   });
    // },
    //删除
    delDocumentFormTable(index, id) {
      this.documentsList.splice(index, 1);
      var ref = "approvalfiles";
      this.$refs[ref][0].del(id);
    },
    download(url) {
      window.open(url);
    },
    preview_video_tips() {
      const h = this.$createElement;
      this.$message({
        message: h("p", null, [
          h("span", null, "格式不支持,不能预览,仅可下载 "),
          h("i", { style: "color:black " }, "")
        ])
      });
      // this.$message('格式不支持,不能预览,仅可下载');
    },
    //拜访详情
    visit_detail(visit_id) {
      window.open(window.visit_url + visit_id);
    },
    //预览
    preview(url, type) {
      if (url.toLowerCase().indexOf(".mp4") < 0 && type == "MP4") {
        this.preview_video_tips();
        return;
        // url = url.replace("/download/","/preview/");
      }
      let routeUrl = this.$router.resolve({
        path: "/preview",
        query: { url: url, type: type }
      });
      window.open(routeUrl.href, "_blank");
      // this.$router.push({path:'/preview',query:{item:item} })
    },
    change_add_document: function() {
      this.upload_file_data.web_token = this.web_token;
      this.upload_file_data.project_id = this.project_id;
    },
    //删除文档
    delDocumentFormList(delDocument_id, delDocument_name, index) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        center: true
      })
        .then(() => {
          this.$http
            .post(
              this.web_url + "/document/" + delDocument_id + "/delete",
              { web_token: this.web_token },
              { emulateJSON: true }
            )
            .then(function(res) {
              if (res.data.status == "ok") {
                this.getDocuments(this.project_id);
                // this.documents_list[index].del = 2;
                // this.documents();
              } else {
              }
            })
            .catch(function(res1) {
              console.log(res1);
            });
        })
        .catch(() => {});
    },
    handleSuccess(res) {
      this.fileList = [];
      console.log(this.upload_file_data);
      this.getDocuments(this.project_id);
    }
  },
  mounted() {
    this.documents_list = this.documents_total;
    this.appUrl = this.web_url + "/download_apk.png";
    this.upload_url = this.web_url + "/document/add";
  },
  created() {}
};
</script>




// WEBPACK FOOTER //
// src/components/projectFile_visitLog.vue